import React from 'react';

const SizeTrouser = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4217_129)">
            <g clipPath="url(#clip1_4217_129)">
                <path
                    d="M20.21 6H3.79004"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.58398 9.88C5.72683 9.87998 7.46394 8.14285 7.46394 6"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.07 22C15.5867 22 15.1726 21.6544 15.0862 21.1789L13.4919 12.4106C13.4487 12.1728 13.2416 12 13 12H11.07C10.8284 12 10.6213 12.1728 10.5781 12.4106L8.98387 21.1789C8.89742 21.6544 8.48328 22 7.99998 22H3.99998C3.4477 22 2.99999 21.5523 3 21C3 20.9825 3.00046 20.965 3.00138 20.9475L3.8961 3.94746C3.92404 3.41633 4.36284 3.00001 4.8947 3H19.1053C19.6371 3.00001 20.0759 3.41631 20.1039 3.94742L20.9986 20.9474C21.0277 21.4989 20.6041 21.9696 20.0526 21.9986C20.0351 21.9995 20.0175 22 20 22L16.07 22Z"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.4161 9.88C18.2733 9.88 16.5361 8.14286 16.5361 6"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4217_129">
                <rect width="24" height="24" fill="white" />
            </clipPath>
            <clipPath id="clip1_4217_129">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default SizeTrouser;
